module.exports = __webpack_public_path__ + "media/images/avatar/21-f722c82618c98873d6df911cc1a1ccc8.svg";